import fetchApi from '../../Services/requests';
import { ContactUsUrl } from '../../Routes/contactUs.route';

export const getContactUsDataAction = async (
  set,
  uniqueId: number
): Promise<void> => {
  set({ contactUsData: null, contactUsLoading: true, contactUsError: false });

  const response = await fetchApi(ContactUsUrl(), { uniqueId });

  response?.ok
    ? set({
        contactUsData: response.data,
        contactUsLoading: false,
        contactUsError: false
      })
    : set({
        contactUsData: null,
        contactUsLoading: false,
        contactUsError: true
      });
};
